import { render } from "./SidebarModal.vue?vue&type=template&id=28238e29"
import script from "./SidebarModal.vue?vue&type=script&lang=js"
export * from "./SidebarModal.vue?vue&type=script&lang=js"

import "./SidebarModal.vue?vue&type=style&index=0&id=28238e29&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__